// App.js
import React from 'react';
import '../App.css';
import ProductCard from './ProductCard';
import Divider from './divider';
import automatedProcessIcon from '../assets/ICONS/Remake/alf.png';
import AdCampaignIcon from '../assets/ICONS/Remake/ads.png';
import MentorIcon from '../assets/ICONS/Remake/mentor.png';
import PaidIcon from '../assets/ICONS/Remake/money.png';
import DocumentIcon from '../assets/ICONS/Remake/files.png';

import WebsiteIcon from '../assets/ICONS/Remake/web.png';
import SocialIcon from '../assets/ICONS/Remake/social-content.png';
import CreationIcon from '../assets/ICONS/Remake/social-tool.png';
import CrowdFundIcon from '../assets/ICONS/Remake/crowd-funding.png';



function Toolkit() {
  const getLeads = [
    
    {
      icon: CrowdFundIcon,
      title: 'Crowd-Funding Ad Spends',
      description: 'Bigger ad budgets result in a lower cost per lead. By pooling our ad dollars together, our agents pay a fraction of the cost most agents have to pay. All the leads are distributed in a blind round robin proportional manner so it is a level playing field for everyone. Prefer to market specific areas or lists? Choose any list or area from our lead center and it will provide the information you need to close the deal.',
    },
    {
      icon: AdCampaignIcon,
      title: 'Personalize Ad Campaigns',
  description: 'Every real estate agent is unique and we all carry a different message. Our CRM will allow you to take templated campaigns and customize them to fit your style. Whether it be a text, email, postcard, snail mail, or outreach to past clients, with the click of a button your follow becomes automated.',

    },
    {
      icon: automatedProcessIcon,
      title: 'Automated Lead Follow-Up',
      description: 'Staying engaged with leads and clients is critical in our business. The issue becomes being able to stay engaged with all of them on a large scale. By leveraging the tech that is available to us, we are able to have our CRM stay engaged, on your direction, until your client is ready to buy or sell. ',

    },
  ];

  const WorkLeads = [
    {
      icon: DocumentIcon,
      title: 'Doc Vault',
      description: 'We know the paperwork seems to be never-ending but with our proprietary system, agents can see all the required forms needed for each transaction while building their database without even trying. This ensures that no details are missed and you close more transactions.  Mentorship – keep all your commission and receive the road map to success by other agents who have a vested stake in your success.',

    },

    {
      icon: MentorIcon,
      title: 'Mentorship Programs',
      description: 'We know that cash flow is important to you. That is why we have partnered with preferred title agency and lenders so you get paid quickly and efficiently.',

    },

    {
      icon: PaidIcon,
      title: 'Get Paid at Closing',
      description: 'Get paid when your deal closes AND the 15th of every month',

    },

  ];

  const branding = [
    {
      icon: WebsiteIcon,
      title: 'Personalized Website',
      description: 'A site built just for you to improve your brand! Your listings will be showcased while providing your clients with built in tools such as Home Finder and the Home Evaluator. Lead Capture is build through out to ensure your leads are nurtured from the beginning. Example',

    },
    {
      icon: SocialIcon,
      title: 'Social Media Content Library',
      description: 'We have a library of content that you can use to post on your social media accounts.',

    },
    {
      icon: CreationIcon,
      title: 'Social Media Creation Tool',
      description: 'Because social media is intended to be personal, we have created a tool that allows you to instantly create your own branded content to post on your social media accounts. You can choose from a variety of templates and customize them to fit your needs.',

    },

  ];

  return (

    <div className="toolkit">

    <div className='center' style={{ backgroundColor: 'transparent', margin: '5em 0' }}>
      <div className='flex' style={{ width: '80%', backgroundColor: 'transparent' }}>
        <div className='auto-scale-text-lg color-primary ' style={{ textAlign: 'left', width: '100%' }}>LEADS</div>
        <div className='auto-scale-text-med color-white ' style={{ textAlign: 'left', width: '100%' }}>THE LIFE BLOOD OF EVERY SALES ORGANIZATION!</div>
        <Divider color='#BCD400' width='90px' margin='30' alignment='left' />


        <div className='text-content color-white' style={{ marginTop: '2rem', textAlign: 'left', width: '100%' }}>Our <span style={{ color: '#BCD400' }}>proprietary CRM & automated lead system</span> provides every agent with an affordable, reliable source of leads that fits their needs.</div>
        
      </div>
    </div>

      <div className="product-card-container">
        {getLeads.map((product, index) => (
          <ProductCard
            key={index}
            icon={product.icon}
            title={product.title}
            description={product.description}

          />
        ))}
      </div>
      <div className='center' style={{ backgroundColor: 'transparent', margin: '5em 0' }}>
      <div className='flex' style={{ width: '80%', backgroundColor: 'transparent' }}>
      <div className='auto-scale-text-lg color-primary ' style={{ textAlign: 'left', width: '100%' }}>ORGANIZED TEAMWORK = MORE PAYDAYS</div>
        <div className='auto-scale-text-med color-white ' style={{ textAlign: 'left', width: '100%' }}>WITH HELPFUL TOOLS TO HELP AUTOMATE THE SALES</div>
        <Divider color='#BCD400' width='90px' margin='30' alignment='left' />


        <div className='text-content color-white' style={{ marginTop: '2rem', textAlign: 'left', width: '100%' }}>Embracing organized teamwork and leveraging helpful automation tools not only streamlines the sales process but also translates into more frequent and lucrative paydays for real estate professionals.</div>
        
      </div>
    </div>
      <div className="product-card-container">
        {WorkLeads.map((product, index) => (
          <ProductCard
            key={index}
            icon={product.icon}
            title={product.title}
            description={product.description}

          />
        ))}
      </div>

      <div>
      <div className='center' style={{ backgroundColor: 'transparent', margin: '5em 0' }}>
      <div className='flex' style={{ width: '80%', backgroundColor: 'transparent' }}>
        <div className='auto-scale-text-lg color-primary ' style={{ textAlign: 'left', width: '100%' }}>BUILD YOUR BRAND</div>
        <div className='auto-scale-text-med color-white ' style={{ textAlign: 'left', width: '100%' }}>WITH CLIENT FACING MARKETING MATERIALS AND SOCIAL MEDIA CONTENT</div>
        <Divider color='#BCD400' width='90px' margin='30' alignment='left' />


        <div className='text-content color-white' style={{ marginTop: '2rem', textAlign: 'left', width: '100%' }}>By offering personalized client-facing materials and social media content, <span style={{ color: '#BCD400' }}>we empower our agents to build their own brand</span> and connect with clients on a more personal level.</div>
        
      </div>
    </div>
    </div>
      <div className="product-card-container">
        {branding.map((product, index) => (
          <ProductCard
            key={index}
            icon={product.icon}
            title={product.title}
            description={product.description}
          />
        ))}
      </div>
    </div>

  );
}

export default Toolkit;